export const DomainEnhancementStrategy = {
    unspecified: 'unspecified',
    replace: 'replace',
    expand: 'expand',
};
//# sourceMappingURL=DomainEnhancement.js.map